import { AppDispatch } from '../../redux/store'
import { getEndOfLife, getEndOfLifeConfiguration } from './api'
import {
  endOfLifeFailure,
  endOfLifeRequest,
  endOfLifeSuccess,
  configuration,
} from '../../redux/endOfLifeSlice'
import { showCorrelationIdError } from '../../redux/correlationIdSlice'

export const fetchEndOfLife = (itemId: string, replace) => async (dispatch: AppDispatch) => {
  try {
    dispatch(endOfLifeRequest())
    const { data } = await getEndOfLife(itemId)
    dispatch(endOfLifeSuccess(data))
  } catch (error: any) {
    if (error.showCorrelationId) {
      dispatch(showCorrelationIdError(error.CorrelationId))
    }
    if (error.response?.status === 400) {
      replace()
    }
    dispatch(endOfLifeFailure(error.message))
  }
}

export const getConfiguration = () => async (dispatch: AppDispatch) => {
  try {
    const { data } = await getEndOfLifeConfiguration()
    dispatch(configuration(data))
  } catch (error: any) {
    if (error.showCorrelationId) {
      dispatch(showCorrelationIdError(error.CorrelationId))
    }
    dispatch(endOfLifeFailure(error.message))
  }
}
